import React, { PropsWithChildren } from "react";

export const TabContainer = ({ children }: PropsWithChildren<unknown>) => {
  return <div className="px-[30px] py-[50px]">{children}</div>;
};
